import { useClientAccountOverview } from '@ukpostbox/client-data';
import { Avatar, AvatarSize } from '@ukpostbox/frontend-framework';

type UserAvatarType = {
	rounded?: boolean;
	size?: AvatarSize;
};

function UserAvatar(props: UserAvatarType) {
	const { data } = useClientAccountOverview();

	return (
		<Avatar
			title={(data?.name as string) || 'Username'}
			size={props.size}
			rounded={props.rounded}
			imageSrc={data?.avatarURL}
		/>
	);
}

export { UserAvatar };
